<template>
  <div class="action-bar">
    <div class="action-bar__actions--left">
      <slot name="left" />
    </div>

    <slot />

    <div class="action-bar__actions--right">
      <slot name="right" />
    </div>
  </div>
</template>

<style lang="scss">
.action-bar {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  white-space: nowrap;
  padding: 32px;
}

.action-bar__actions {
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;

  &--left {
    @extend .action-bar__actions;
    grid-gap: 8px;
  }
  &--right {
    @extend .action-bar__actions;
    grid-gap: 8px;
  }
}
</style>
